import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchJobRequest } from "../actions/job";
import { toggleSideBar } from "../actions/settings";
import JobForm from "../components/JobForm";

class JobContainer extends PureComponent {
  render() {
    const { isFetching, jobId, endpoint } = this.props;
    return (
      <JobForm
        fetchJobRequest={this.props.fetchJobRequest}
        toggleSideBar={this.props.toggleSideBar}
        showSideBar={this.props.showSideBar}
        isFetching={isFetching}
        jobId={jobId}
        endpoint={endpoint}
      />
    );
  }

  componentDidMount = () => {
    const { endpoint, jobId } = this.props;

    if (!!jobId) {
      this.props.fetchJobRequest(endpoint, jobId);
    }
  };
}

JobContainer.propTypes = {
  jobId: PropTypes.string,
  endpoint: PropTypes.string,
  isFetching: PropTypes.bool,
  fetchJobRequest: PropTypes.func.isRequired,
  toggleSideBar: PropTypes.func.isRequired,
  showSideBar: PropTypes.bool,
};

function mapStateToProps({
  jobReducer: { isFetching },
  settingsReducer: { showSideBar },
}) {
  return { isFetching, showSideBar };
}

export default connect(mapStateToProps, { fetchJobRequest, toggleSideBar })(
  JobContainer
);
